import { render, staticRenderFns } from "./_Notification.vue?vue&type=template&id=4016256c&scoped=true&"
import script from "./_Notification.vue?vue&type=script&lang=js&"
export * from "./_Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4016256c",
  null
  
)

export default component.exports